const mainMenuSections = [
  "Головна",
  "Про нас",
  "Наші проекти",
  "Сторінки",
  "Блог",
];
const mainMenuSectionsLinks = [
  "/",
  "/aboutUs",
  "/ourProjects",
  "/pages",
  "/blog",
];

const subMenuSectionsPages = ["Новини", "Бібліотека", "Галерея"];
const subMenuSectionsPagesLinks = ["/news", "/library", "/gallery"];

const subMenuSectionsProjects = ["Опис проектів", "Опис проведених подій"];
const subMenuSectionsProjectsLinks = [
  "/projectsDescription",
  "/eventsDescription",
];

const mobileMenuSections = [
  "Головна",
  "Про нас",
  "Опис проектів",
  "Опис проведених подій",
  "Новини",
  "Галерея",
  "Бібліотека",
  "Блог",
  "Контакти",
];
const mobileMenuSectionsLinks = [
  "/",
  "/aboutUs",
  "/projectsDescription",
  "/eventsDescription",
  "/news",
  "/gallery",
  "/library",
  "/blog",
  "https://www.facebook.com/women.in.community.zd/",
];

export {
  mainMenuSections,
  subMenuSectionsPagesLinks,
  subMenuSectionsProjectsLinks,
  mainMenuSectionsLinks,
  subMenuSectionsPages,
  subMenuSectionsProjects,
  mobileMenuSections,
  mobileMenuSectionsLinks,
};
